const RechargePayBillApi=[
    {
        id:1,
        logo:"fas fa-mobile-alt",
        info1:"Recharge",
        info2:"Prepaid",
        info3:"Mobile",
        info4:"fas fa-angle-right"
    },
    {
        id:2,
        logo:"fa fa-rupee-sign",
        info1:"Pay",
        info2:"Any",
        info3:"Rent",
        info4:"fas fa-angle-right"
    },
    {
        id:3,
        logo:"far fa-lightbulb",
        info1:"Pay",
        info2:"Electricity",
        info3:"Bill",
        info4:"fas fa-angle-right"
    },
    {
        id:4,
        logo:"fas fa-wifi",
        info1:"Recharge",
        info2:"DTH",
        info3:"Pay",
        info4:"fas fa-angle-right"
    },
    {
        id:5,
        logo:"far fa-credit-card",
        info1:"Credit",
        info2:"Card",
        info3:"Bill",
        info4:"fas fa-angle-right"
    },
    {
        id:6,
        logo:"fas fa-layer-group",
        info1:"All",
        info2:"Payment",
        info3:"Service",
        info4:"fas fa-angle-right"
    },
    
   
]


export default RechargePayBillApi